import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import PlacesSearchBox from 'common/components/core/map/PlacesSearchBox';
import theme from './LocationSearch.scss';
import MlFontIcon from 'common/components/core/font_icon/MlFontIcon';

class LocationCardSearchBox extends Component {
    render() {
        var {
            title,
            searchLabel,
            subtitle,
            onChange,
            searchLabelColor,
            theme,
            customerName,
            customerContact,
            autoFocusSearchBox,
            t,
            getRadiusAndCenter,
            isEditable
        } = this.props;
        return (
            <div className={theme.locationSearchBoxWrap}>
                <PlacesSearchBox
                    disabled={!isEditable}
                    name={title}
                    selectedAddress={subtitle}
                    onPlacesChanged={onChange}
                    theme={theme}
                    label={searchLabel}
                    placeholder={t('moveMarkerToAddress')}
                    autoFocus={autoFocusSearchBox}
                    className={theme[searchLabelColor]}
                    getRadiusAndCenter={getRadiusAndCenter}
                />
                {customerName || customerContact ? (
                    <div className={theme.bottomMeta}>
                        {customerName ? (
                            <div className={theme.item}>
                                <MlFontIcon
                                    iconClass="customer-icon"
                                    className={theme.icon}
                                />
                                <span>{customerName}</span>
                            </div>
                        ) : null}
                        {customerContact ? (
                            <div className={theme.item}>
                                <MlFontIcon
                                    iconClass="contact-icon"
                                    className={theme.icon}
                                />
                                <span>{customerContact}</span>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );
    }
}
const ThemedLocationCardSearchBox = compose(
    themr('LocationCardSearchBox', theme),
    translate('translations')
)(LocationCardSearchBox);
export { ThemedLocationCardSearchBox as LocationCardSearchBox };
export default ThemedLocationCardSearchBox;
